<template>
  <div id="muCalssDretails">
    <a-page-header title="班级课程" @back="$router.go(-1)" />
    <div class="deatilsHeader">
      <img class="details_header_img" :src="detailsInfo.departCover_url" alt="">
      <ul class="details_header_content">
        <li class="content_title">{{ detailsInfo.departName }}</li>
        <li class="content_text">
          <p class="p_title">课程简介：</p>
          <p class="p_content">{{ detailsInfo.departDesc }}</p>
        </li>
        <li class="content_text">课程节数：{{ courseList.length }}节</li>
        <!-- <li class="content_text">班级类型：面授课</li> -->
        <!-- <li class="content_text">班级名称：1班</li> -->
      </ul>
    </div>
    <div>
      <a-tabs v-model="tabActiveKey">
        <a-tab-pane key="1" tab="课程目录">
          <ul class="ul_box">
            <li class="list_box" v-for="item, index in courseList " :key="index">
              <img :src="item.courseCover_url" alt="" class="list_img">
              <div class="list_content">
                <p class="content_title">{{ item.courseName }}</p>
                <p class="content_text">{{ item.courseDesc }}</p>
                <!-- <p class="content_text">2023-11-28 20:13:00-22:14:00</p> -->
              </div>
              <div class="list_operate"> <a-button type="primary" shape="round" style="margin-top: 20px;"
                  @click="toDetail(item.id)">进入课程</a-button></div>
            </li>
          </ul>
        </a-tab-pane>
        <a-tab-pane key="2" tab="学员信息" v-if="userIdentity == 2">
          <studentList />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import studentList from './components/studentList.vue';
import { getAction } from '@/api/manage'
export default {
  name: 'muCalssDretails',
  props: ['info'],
  watch: {
    info(e) {
      this.listInfo = e
    }
  },
  components: { studentList },
  data() {
    return {
      listInfo: {},
      tabActiveKey: "1",
      detailsInfo: {},
      courseList: []
    }
  },
  computed: {
    userIdentity() {
      return this.$store.state.user.info.userIdentity;
    },
  },
  created() { this.listInfo = this.info, this.init(this.$route.query.id) },
  mounted() { },
  methods: {
    init(id) {
      let _this = this
      getAction(`/sys/sysDepart/departDetail?departId=${id}`).then(res => {
        if (res.success) {
          this.detailsInfo = res.result
          getAction(`/teaching/teachingCourse/studentCourseNew?departId=${id}`).then(result => {
            if (result.success) {
              _this.courseList = result.result
            }
          })
        }
      })
    },
    toDetail(id) {
      this.$router.push({
        path: 'courseDetail',
        query: {
          id: id,
        },
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.ant-page-header {
  padding: 0px 0 10px 0 !important;
}

#muCalssDretails {
  width: 100%;
  // height: 100%;
  background: #fff;
  padding: 15px;

  .deatilsHeader {
    width: 100%;
    height: 200px;

    .details_header_img {
      width: 240px;
      height: 160px;
      background: #fff;
      border-radius: 5px;
      float: left;
    }

    .details_header_content {
      float: left;
      width: calc(100% - 260px);
      height: auto;
      margin-left: 20px;

    }
  }
}
</style>
  